<template>
  <!-- 云端运行日志 -->
  <div>
    <div>
      <div class="mb10">
        <!-- <v-input
              class=""
              v-model="searchValue"
              placeholder="请输入搜索内容"
              suffix-icon="v-icon-search"
              @change="getData"
        ></v-input> -->
        <v-button class="" type="primary" name="" @click="showDelAllModel">删除全部</v-button>
      </div>
      <div id="table">
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
          ref="box"
        >
          <vxe-table-column
            field="level"
            show-overflow
            min-width="120"
            title="日志等级"
          ></vxe-table-column>
          <vxe-table-column
            field="device_key"
            show-overflow
            min-width="120"
            title="设备Key"
          ></vxe-table-column>
          <vxe-table-column
            field="topic"
            show-overflow
            min-width="120"
            title="topic"
          ></vxe-table-column>
          <vxe-table-column
            field="message"
            show-overflow
            min-width="120"
            title="运行信息"
          ></vxe-table-column>
          <vxe-table-column
            field="payload"
            show-overflow
            min-width="120"
            title="设备数据"
          ></vxe-table-column>
          <vxe-table-column
            field="record_time"
            show-overflow
            min-width="120"
            title="运行时间"
          ></vxe-table-column>
          <vxe-column title="操作" min-width="100">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn2"
                  slot="reference"
                  @click="showDelModel(slotProps.row)"
                  >删除</v-button
                ></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-loading class="loading-box" size="L" :visible="tabisloading" text="加载中..." name="loading1"></v-loading>
    </div>
    <Del
      :showInputDialog.sync="Delloading"
      ref="Del"
      :id="Id"
      @tableDel="tableDel"
    ></Del>
    <DelAll
      :showInputDialog.sync="DelAllloading"
      ref="Del"
      @tableDelAll="tableDelAll"
    ></DelAll>
  </div>
</template>

  <script>
import Del from "@/components/log-service/online/del.vue";
import DelAll from "@/components/log-service/online/del-all.vue";

export default {
  components: { Del, DelAll },
  props:{
    productKey:{},
    deviceKey:{}
  },
  data() {
    return {
      DelAllloading: false,
      Delloading: false,
      tabisloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      table: [],
      Id: "",
      search_after:''
    };
  },
  watch:{
    deviceKey(newdata){
      this.search_after = ''
      this.deviceKey = newdata
    },
    productKey(newdata){
      this.search_after = ''
      this.productKey = newdata
    },
  },
  created() {
    this.getData();
  },
  mounted () {
    document.getElementsByClassName('vxe-table--body-wrapper')[0].addEventListener('scroll', this.throttle(this.lazyLoading, 1000))
  },
  methods: {
     //节流函数
     throttle  (fn, delay) {
        var timer = null;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn();
            }, delay);
        }
    },
    lazyLoading () {
        const target = document.getElementsByClassName('vxe-table--body-wrapper')[0]
        const scrollTop = target.scrollTop // 滚动条滚动时，距离顶部的距离
        const windowHeight = target.clientHeight // 可视区的高度
        const scrollHeight = target.scrollHeight // 滚动条的总高度
        if (scrollTop + windowHeight + 1 > scrollHeight) {
          //数据小于每组数量  已到最后一页
          if(this.pageSize > this.total){
            this.$message.warn('已经是最后一页了');
            return
          }
          this.tabisloading = true
          this.getData();
        }
    },
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    search(){
      this.table = []
      this.search_after = ''
      this.getData()
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        // page_num: this.currentPage,
        size: this.pageSize,
        device_key: this.deviceKey,
        product_key: this.productKey,
        search_after: this.search_after == '' ? [] : [this.search_after]
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/log/dev/running/get/list/v1",
        subData,
        false
      );
      if (res.code === 0) {
        if(!this.search_after && res.data.search_after.length === 0){
          this.table = []
        }
        res.data.list.map((item)=>{
          this.table.push(item)
        })
        this.total = res.data.total;
        this.search_after = res.data.search_after[0]
        this.tabisloading = false
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },

    tableDel (_id) {
      this.table = this.table.filter( item => item._id != _id)
    },
    tableDelAll () {
      this.table = []
    },

    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.getData();
    },
    showDelModel(row) {
      this.Id = row._id;
      this.Delloading = !this.Delloading;
    },
    showDelAllModel() {
      this.DelAllloading = !this.DelAllloading;
    },
  },
};
</script>
  <style lang="scss">
.low-title {
  font-size: 18px;
}
#table .vxe-table--body-wrapper{
  max-height: 530px;
}
</style>
